"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var MyAccountMiniContainer_1 = require("../../../../../common/components/myAccountDxp/MyAccountMiniContainer");
var GoHomeButton_1 = require("../GoHomeButton/GoHomeButton");
var MySummaryExpandedCtaContainerStyles_1 = require("./MySummaryExpandedCtaContainerStyles");
exports.MySummaryExpandedCtaContainer = function (_a) {
    var homePageURL = _a.homePageURL, myAccountDxpIntegration = _a.myAccountDxpIntegration;
    var style = MySummaryExpandedCtaContainerStyles_1.default();
    return (<core_1.Grid container spacing={1}>
      <core_1.Grid item xs={6}>
        <GoHomeButton_1.default homePageURL={homePageURL} myAccountDxpIntegration={myAccountDxpIntegration}/>
      </core_1.Grid>
      <core_1.Grid item xs={6} className={style.myAccountButtonContainer}>
        <MyAccountMiniContainer_1.default dataTestId={'checkout:confirmation:myaccountmini'} loginInModal={false}/>
      </core_1.Grid>
    </core_1.Grid>);
};
